import axios from "axios";
import * as Icons from "heroicons-react";
import { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useForm } from "react-hook-form";
import { Toaster } from "react-hot-toast";
import { Form, useNavigate } from "react-router-dom";
import {
  useAddProductMutation,
  useProductCountQuery
} from "../../services/productApi";
import CategorySelectByMC from "../Common/CustomSelect/categorySelectByMC";
import SelectBrand from "../Common/CustomSelect/selectBrand";
import SelectCategoryGroup from "../Common/CustomSelect/selectCategoryGroup";
import SelectMC from "../Common/CustomSelect/selectMC";
import SelectUnit from "../Common/CustomSelect/selectUnit";
import Header from "../Common/Header/Header";
import LoadingModal from "../Common/Modal/LoadingModal";
import SideBar from "../Common/SideBar/SideBar";
import { signInUser } from "../Utility/Auth";
import { notify } from "../Utility/Notify";
import { apiUniqueErrHandle } from "../Utility/Utility";
import PackageModal from "../Common/Modal/PackageModal";
import ProductPriceModal from "../Common/Modal/ProductPriceModal";

const AddProduct = () => {
  const BASE_URL =process.env.REACT_APP_API_URL || "http://localhost:5001/api/";
  let navigate = useNavigate();
  const {
    register,
    handleSubmit,
    control,
    setError,
    clearErrors,
    watch,
    setValue,
    reset,
    formState: { errors }
  } = useForm({});
  const [mg, setMg] = useState("");
  const [mc, setMc] = useState("");
  const [sc, setSc] = useState("");
  const [scValue, setScValue] = useState("");
  const [brand, setBrand] = useState([]);
  const [unit, setUnit] = useState([]);
  const [AddProduct] = useAddProductMutation();
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const [isEANUnique, setIsEANUnique] = useState(true);
  const [isArticleCodeUnique, setIsArticleCodeUnique] = useState(true);
  const [loader, setLoader] = useState(false);
  const handleLoaderClose = () => setLoader(false);
  const auth = signInUser();
  const { aamarId } = auth;
  const { data: countData } = useProductCountQuery({ aamarId });
  const [modalVisible, setModalVisible] = useState(false);
  const closeModal = () => setModalVisible(false);
  const [promoType, setPromoType] = useState(false);

  const eanValue = watch("ean"); // Watches the 'ean' field value
  const articleCodeValue = watch("article_code");
//  slug create in Product name
const [slug, setSlug] = useState("");

// handle change in slug field
const handleNameChange = (e) => {
  const name = e.target.value;
  // Generate slug in real-time
  const generatedSlug = name.trim().toLowerCase().replace(/\s+/g, "_");
  setSlug(generatedSlug);
  setValue("slug", generatedSlug); // Update slug in react-hook-form
};

// random number set to ean & article code
  useEffect(() => {
    const isEANValid = eanValue && /^[0-9]+$/.test(eanValue); // Check if eanValue is a number
    if (isEANValid) {
      checkEan(eanValue);
    }

    const isAcValid = articleCodeValue && /^[0-9]+$/.test(articleCodeValue); // Check if articleCodeValue is a number
    if (isAcValid) {
      checkAC(articleCodeValue);
    }
  }, [eanValue, articleCodeValue]);

  // check EAN Code Value
  const checkEan = async (ean) => {
    // console.log(ean);
    try {
      const eanData = await axios.get(
        `${BASE_URL}product/uniqueEan/${aamarId}/${ean}`
      );
      const { eanExists } = eanData.data; // Correct property name
      if (eanExists) {
        setIsEANUnique(false);
        setError("ean", { message: "EAN code already exists!" });
      } else {
        setIsEANUnique(true);
        clearErrors("ean");
      }
    } catch (error) {
      console.error("Error checking EAN code:", error);
    }
  };

  // check Article Code Value
  const checkAC = async (ac) => {
    try {
      // console.log(ac);
      const acData = await axios.get(
        `${BASE_URL}product/uniqueAc/${aamarId}/${ac}`
      );
      const { acExists } = acData.data; // Ensure this matches the backend response

      if (acExists) {
        setIsArticleCodeUnique(false);
        setError("article_code", { message: "Article code already exists!" });
      } else {
        setIsArticleCodeUnique(true);
        clearErrors("article_code");
      }
    } catch (error) {
      console.error("Error checking Article Code:", error);
    }
  };

  // console.log(eanValue, articleCodeValue)

  // console.log("Count DATA", countData);
  console.log("productLimited", auth?.storeSettings?.isEnableApi);

  const handelAddProduct = async (data) => {
    setLoader(true);

    //@ts-ignore
    if (countData >= auth?.package?.productLimited) {
      setModalVisible(true);
      return;
    } else {
      try {
        // Assuming `AddProduct` handles the API request to add a product
        const response = await AddProduct({
          ...data,
          aamarId
        });

        // console.log("data", data);

        if (response) {
          // console.log(response);
          if (response?.error) {
            const check = apiUniqueErrHandle(response);
            if (!check.status) {
              for (const key in check.option) {
                notify(`${key}: ${check.option[key]} is not unique`, "error");
              }
            }
          } else {
            // Reset the form fields
            setMg("");
            setMc("");
            setSc("");
            setScValue("");
            reset({
              _id: "",
              name: "",
              ean: "",
              article_code: "",
              group: "",
              master_category: "",
              category: "",
              product_type: "",
              priceList: "",
              brand: "",
              slug: "",
              details: "",
              unit: "",
              alert_quantity: "",
              weightScale: "",
              vat: "",
              vat_method: "",
              featured: "",
              shipping_method: "",
              hide_website: "",
              promo_price: "",
              promo_start: "",
              promo_end: "",
              photo: "",
              status: ""
            });

            // Show success message
            notify(
              response?.data?.message || "Product added successfully!",
              "success"
            );
            return navigate("/product");
          }
        }
      } catch (err) {
        console.log(err);
      } finally {
        setLoader(false);
      }
    }
  };

  // GROUP SELECT HANDLE
  const handleOnchangeGroup = (selectedId) => {
    const gid = selectedId || "";
    setMg(gid);
    setValue("group", gid);
    // Reset Master Category and Category when Group changes
    setMc("");
    setValue("master_category", "");
    setSc("");
    setScValue("");
    setValue("category", "");
  };

  // MASTER CATEGORY SELECT HANDLE
  const handleOnchangeMasterCategory = (e) => {
    if (e && e?.option) {
      setMc(e.option);
      setValue("master_category", e.option, {
        shouldValidate: true,
        shouldDirty: true
      });

      if (e?.label) {
        const mId = e.label.split(" - ");
        setSc(mId[1]);
      }

      // If group is not selected, auto-set group if MC has group
      if (e?.group) {
        const gid = typeof e.group === "object" ? e.group._id : e.group;
        if (gid && !mg) {
          setMg(gid);
          setValue("group", gid);
        }
      }

      // Reset category when master category changes
      setScValue("");
      setValue("category", "");
    } else {
      setMc("");
      setValue("master_category", "");
      setSc("");
      setScValue("");
      setValue("category", "");
    }
  };

  // Sub Category SELECT HANDLE
  const handleOnchangeCategory = (e) => {
    const catId = e?.option || e?.value || "";
    setScValue(catId);
    setValue("category", catId, {
      shouldValidate: true,
      shouldDirty: true
    });

    if (e) {
      // Auto-set parent Category if not selected yet
      if (e.mc && !mc) {
        const parentMcId = typeof e.mc === "object" ? e.mc._id : e.mc;
        if (parentMcId) {
          setMc(parentMcId);
          setValue("master_category", parentMcId, {
            shouldValidate: true,
            shouldDirty: true
          });
        }
      }

      // Auto-set Group if not selected yet
      if (e.group && !mg) {
        const gid = typeof e.group === "object" ? e.group._id : e.group;
        if (gid) {
          setMg(gid);
          setValue("group", gid);
        }
      }
    }
  };

  //Brand
  const handleOnChangeBand = (e) => {
    setBrand(e.option);
    setValue("brand", e.option, {
      shouldValidate: true,
      shouldDirty: true
    });
  };

  const handleOnchangeUnit = (e) => {
    setUnit(e.option);
    setValue("unit", e.option, {
      shouldValidate: true,
      shouldDirty: true
    });
  };

  const handlePromoStart = (date) => {
    setStartDate(date);
    setValue("promo_start", startDate, {
      shouldValidate: true,
      shouldDirty: true
    });
  };

  const handlePromoEnd = (date) => {
    setEndDate(endDate);
    setValue("promo_end", startDate, {
      shouldValidate: true,
      shouldDirty: true
    });
  };

  const handlePromoType = (e) => {
    setPromoType(!promoType);
    setValue("promo_type", !promoType, {
      shouldValidate: true,
      shouldDirty: true
    });
  };

  return (
    <div>
      <div className="container-fluid">
        <LoadingModal
          title={"Please Wait"}
          onShow={loader}
          handleClose={handleLoaderClose}
        ></LoadingModal>
        <div className="row">
          <div className="col-md-2">
            <SideBar></SideBar>
          </div>
          <div className="col-md-10 mb-4">
            <Header title="Add New Product"></Header>
            <div className="row">
              <div className="col-md-8 offset-md-2">
                <form
                  onSubmit={handleSubmit(handelAddProduct)}
                  className="mt-4"
                >
                  {/* 1st row */}
                  <div className="row">
                    <div className="col-md-3">
                      <div className="mb-3">
                        <label htmlFor="p_group" className="form-label">
                          Group
                        </label>
                        <SelectCategoryGroup
                          mg={mg}
                          handleOnchange={handleOnchangeGroup}
                        />
                        <div id="groupHelp" className="form-text">
                          Product Group
                        </div>
                      </div>
                    </div>

                    <div className="col-md-3">
                      <div className="mb-3">
                        <label htmlFor="masterCategory" className="form-label">
                          Category
                        </label>

                        {/* Hidden input for react-hook-form validation */}
                        <input
                          type="hidden"
                          className="form-control"
                          {...register("master_category", {
                            required: "* Category is Required" // Custom error message
                          })}
                        />

                        {/* Custom Select component */}
                        <SelectMC
                          handleOnchange={(e) =>
                            handleOnchangeMasterCategory(e)
                          }
                          mc={mc}
                          groupId={mg}
                          placeholder="Select Category..."
                        />

                        {/* Error message for master_category field */}
                        {errors.master_category && (
                          <span className="text-danger mt-2">
                            {errors.master_category.message}
                          </span>
                        )}

                        <div id="masterHelp" className="form-text">
                          Product Category
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="mb-3">
                        <label htmlFor="ean" className="form-label">
                          EAN Code
                        </label>

                        {/* EAN input with react-hook-form validation */}
                        <input
                          placeholder="EAN CODE"
                          className="form-control"
                          id="ean"
                          aria-describedby="eanHelp"
                          {...register("ean", {
                            required: "* This Field is Required", // Custom error message
                            maxLength: {
                              value: 13,
                              message: "EAN code cannot exceed 13 characters"
                            }
                          })}
                        />
                        {/* Error message for EAN Code field */}
                        {errors.ean && (
                          <span className="text-danger mt-2">
                            {errors.ean.message}
                          </span>
                        )}

                        {!isEANUnique && (
                          <span className="text-danger">
                            EAN code already exists!
                          </span>
                        )}

                        <div id="eanHelp" className="form-text">
                          International EAN CODE
                        </div>
                      </div>
                    </div>

                    <div className="col-md-3">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="p_type">
                          Product Type
                        </label>

                        {/* Product Type select with react-hook-form validation */}
                        <select
                          className="form-select"
                          {...register("product_type", {
                            required: "* This Field is Required"
                          })}
                        >
                          <option value="standard">Standard</option>
                          <option value="combo">Combo</option>
                          <option value="offer">Offer</option>
                        </select>

                        {/* Error message for Product Type field */}
                        {errors.product_type && (
                          <span className="text-danger mt-2">
                            {errors.product_type.message}
                          </span>
                        )}

                        <div id="typeHelp" className="form-text">
                          Single or Combo Product
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* 2nd row */}
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="p_name">
                          Product Name
                        </label>

                        {/* Product Name input with react-hook-form validation */}
                        <input
                          placeholder="Product name"
                          className="form-control"
                          id="p_name"
                          aria-describedby="nameHelp"
                          {...register("name", {
                            required: "* This Field is Required" ,// Custom error message
                            onChange: handleNameChange,
                          })}
                        />
                        {/* Error message for Name field */}
                        {errors.name && (
                          <span className="text-danger mt-2">
                            {errors.name.message}
                          </span>
                        )}

                        <div id="nameHelp" className="form-text">
                          Product Name with pack size
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="p_article_code">
                          Article Code
                        </label>

                        {/* Article Code input with react-hook-form validation */}
                        <input
                          placeholder="Article Code"
                          className="form-control"
                          id="p_article_code"
                          aria-describedby="article_codeHelp"
                          {...register("article_code", {
                            required: "* This Field is Required", // Custom error message
                            maxLength: {
                              value: 13,
                              message:
                                "Article Code cannot exceed 13 characters"
                            }
                          })}
                        />
                        {/* Error message for Article Code field */}
                        {errors.article_code && (
                          <span className="text-danger mt-2">
                            {errors.article_code.message}
                          </span>
                        )}

                        {!isArticleCodeUnique && (
                          <span className="text-danger">
                            Article code already exists!
                          </span>
                        )}

                        <div id="article_codeHelp" className="form-text">
                          Article code starts with Master Category id
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* 3rd row  */}
                  <div className="row">
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="p_brand">
                          Brand
                        </label>

                        {/* Hidden input for react-hook-form validation */}
                        <input
                          type="hidden"
                          placeholder="Brand"
                          className="form-control"
                          id="p_brand"
                          aria-describedby="brandHelp"
                          {...register("brand")}
                        />

                        {/* Custom Select component */}
                        <SelectBrand
                          brand={brand}
                          handleOnchange={(e) => handleOnChangeBand(e)}
                        />

                        <div id="brandHelp" className="form-text">
                          Product Brand
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="p_category">
                          Sub Category
                        </label>

                        {/* Hidden input for react-hook-form validation */}
                        <input
                          type="hidden"
                          placeholder="Sub Category"
                          className="form-control"
                          id="p_category"
                          aria-describedby="categoryHelp"
                          {...register("category")}
                        />

                        {/* Custom Category Select component */}
                        <CategorySelectByMC
                          scValue={scValue}
                          sc={sc}
                          mcId={mc}
                          handleOnChangeCategory={(e) =>
                            handleOnchangeCategory(e)
                          }
                          placeholder="Select Sub Category..."
                        />

                        {/* Error message for Category */}
                        {errors.category && (
                          <span className="text-danger mt-2">
                            {errors.category.message}
                          </span>
                        )}

                        <div id="categoryHelp" className="form-text">
                          Product Sub Category
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="p_slug">
                          Slug
                        </label>

                        {/* Slug input with react-hook-form validation */}
                        <input
                          placeholder="Slug"
                          className="form-control"
                          id="p_slug"
                          aria-describedby="slugHelp"
                          {...register("slug", {
                            required: "* This Field is Required" // Custom error message
                          })}
                          value={slug}
                        />

                        {/* Error message for Slug */}
                        {errors.slug && (
                          <span className="text-danger mt-2">
                            {errors.slug.message}
                          </span>
                        )}

                        <div id="slugHelp" className="form-text">
                          Article code starts with Master Category id
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* 4th row  */}
                  <div className="row">
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="p_unit_code">
                          Product Unit
                        </label>

                        {/* Hidden input for react-hook-form validation */}
                        <input
                          type="hidden"
                          placeholder="Product Unit"
                          className="form-control"
                          id="p_unit_code"
                          aria-describedby="unit_codeHelp"
                          {...register("unit")}
                        />

                        {/* Custom Select component for Unit */}
                        <SelectUnit
                          unit={unit}
                          handleOnchange={(e) => handleOnchangeUnit(e)}
                        />

                        {/* Error message for Product Unit */}
                        {errors.unit && (
                          <span className="text-danger mt-2">
                            {errors.unit.message}
                          </span>
                        )}

                        <div id="unit_codeHelp" className="form-text">
                          Article code starts with Master Category id
                        </div>
                      </div>
                    </div>

                    <div className="col-md-3">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="p_slug">
                          Alert Quantity
                        </label>

                        {/* Alert Quantity input with react-hook-form validation */}
                        <input
                          type="number"
                          placeholder="Alert Quantity"
                          className="form-control"
                          id="p_slug"
                          aria-describedby="slugHelp"
                          {...register("alert_quantity", {
                            required: "* This Field is Required", // Custom error message
                            maxLength: {
                              value: 20,
                              message:
                                "Alert Quantity cannot exceed 20 characters"
                            }
                          })}
                        />

                        {/* Error message for Alert Quantity */}
                        {errors.alert_quantity && (
                          <span className="text-danger mt-2">
                            {errors.alert_quantity.message}
                          </span>
                        )}

                        <div id="slugHelp" className="form-text">
                          Article code starts with Master Category id
                        </div>
                      </div>
                    </div>

                    {/* weightScale field */}
                    <div className="col-md-5">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="p_weightScale_code"
                        >
                          Weight Scale
                        </label>

                        {/* Product Type select with react-hook-form validation */}
                        <select
                          className="form-select"
                          {...register("weightScale", {
                            required: "* This Field is Required"
                          })}
                        >
                          <option value="false">Inactive</option>
                          <option value="true">active</option>
                        </select>

                        {/* Error message for Product weightScale */}
                        {errors.weightScale && (
                          <span className="text-danger mt-2">
                            {errors.weightScale.message}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* 6th row */}
                  <div className="row">
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="p_vat">
                          VAT
                        </label>
                        <div className="position-relative">
                          <input
                            type="number"
                            placeholder="VAT"
                            className="form-control rounded pe-5" // Add padding on the right
                            id="p_vat"
                            aria-describedby="vatHelp"
                            {...register("vat", {
                              required: "* This Field is Required", // Custom error message
                              maxLength: {
                                value: 20,
                                message: "VAT cannot exceed 20 characters"
                              }
                            })}
                          />
                          <span
                            className="position-absolute top-50 end-0 border-start bg-light py-1 ps-2 translate-middle-y pe-3 me-1"
                            style={{ fontSize: "18px" }}
                          >
                            %
                          </span>
                        </div>

                        {/* Error message for VAT */}
                        {errors.vat && (
                          <span className="text-danger mt-2">
                            {errors.vat.message}
                          </span>
                        )}

                        <div id="vatHelp" className="form-text">
                          Article code starts with Master Category ID
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="p_vat_method">
                          Vat Method
                        </label>
                        <select
                          className="form-select"
                          {...register("vat_method")}
                        >
                          <option value="true">Include</option>
                          <option value="false">Exclude</option>
                        </select>

                        <div id="vat_methodHelp" className="form-text">
                          Vat Include or Not
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="p_status">
                          Status
                        </label>
                        <select className="form-select" {...register("status")}>
                          <option value="active">Active</option>
                          <option value="inactive">Inactive</option>
                        </select>

                        <div id="statusHelp" className="form-text">
                          Is this product visible on E-commerce?
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* 7th row */}
                  {auth?.storeSettings?.isEnableApi ? (
                    <>
                      <div className="row">
                        <div className="col-md-4">
                          <div className="mb-3">
                            <label className="form-label" htmlFor="p_featured">
                              Featured
                            </label>
                            <select
                              className="form-select"
                              {...register("featured")}
                            >
                              <option value="true">Featured</option>
                              <option value="false">Non-Featured</option>
                            </select>

                            <div id="featuredHelp" className="form-text">
                              Is this product featured on E-commerce?
                            </div>
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="mb-3">
                            <label
                              className="form-label"
                              htmlFor="p_hide_website"
                            >
                              Web Site
                            </label>
                            <select
                              className="form-select"
                              {...register("hide_website")}
                            >
                              <option value="true">Show Web Site</option>
                              <option value="false">Hide Web Site</option>
                            </select>

                            <div id="hide_on_websiteHelp" className="form-text">
                              Is this product hidden on E-commerce?
                            </div>
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="mb-3">
                            <label className="form-label" htmlFor="p_shipping">
                              Shipping Method
                            </label>
                            <select
                              className="form-select"
                              {...register("shipping")}
                            >
                              <option value="cod">COD</option>
                              <option value="free">Free Shipping</option>
                              <option value="uttara">Inside Uttara</option>
                            </select>

                            <div id="shippingHelp" className="form-text">
                              What is the delivery method?
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* 8th row */}
                      <div className="row">
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label
                              className="form-label"
                              htmlFor="p_product_details"
                            >
                              Product Description
                            </label>
                            <textarea
                              placeholder="Product Description"
                              className="form-control"
                              id="p_product_details"
                              aria-describedby="product_detailsHelp"
                              {...register("details", { required: false })}
                            />
                            <div id="product_detailsHelp" className="form-text">
                              Product Details for E-commerce
                            </div>
                          </div>
                        </div>

                        <div className="col-md-12">
                          <div className="mb-3">
                            <label
                              className="form-label"
                              htmlFor="p_product_specification"
                            >
                              Product Specification
                            </label>
                            <textarea
                              placeholder="Product Specification"
                              className="form-control"
                              id="p_product_specification"
                              aria-describedby="product_specificationHelp"
                              {...register("specification", {
                                required: false
                              })}
                            />
                            <div
                              id="product_specificationHelp"
                              className="form-text"
                            >
                              Product Specifications for E-commerce
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                  {/* 9th Row */}
                  <div className="row">
                    {/* Promotional Price */}
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label
                          htmlFor="p_promotional_price"
                          className="form-label"
                        >
                          Promotional Price
                        </label>
                        <input
                          type="number"
                          id="p_promotional_price"
                          className="form-control"
                          placeholder="Promotional Price"
                          aria-describedby="promotional_priceHelp"
                          {...register("promo_price", { required: false })}
                        />
                        <div id="promotional_priceHelp" className="form-text">
                          Product Cost
                        </div>
                      </div>
                    </div>

                    {/* Promotion Starts */}
                    <div className="col-md-4 align-content-end">
                      <div className="mb-3">
                        <label
                          htmlFor="p_promotion_start"
                          className="form-label"
                        >
                          Promotion Start
                        </label>
                        <DatePicker
                          id="p_promotion_start"
                          className="form-control"
                          wrapperClassName="datePicker"
                          openCalendarOnFocus
                          showTimeSelect
                          selected={startDate}
                          onChange={handlePromoStart}
                          {...register("promo_start")}
                          dateFormat="MM/dd/yyyy"
                        />
                        <div id="promotion_startHelp" className="form-text">
                          Start date of the promotional period
                        </div>
                      </div>
                    </div>

                    {/* Promotion Ends */}
                    <div className="col-md-4 align-content-end">
                      <div className="mb-3">
                        <label
                          htmlFor="p_promotion_ends"
                          className="form-label"
                        >
                          Promotion End
                        </label>
                        <DatePicker
                          id="p_promotion_ends"
                          className="form-control pr-1"
                          wrapperClassName="datePicker"
                          openCalendarOnFocus
                          showTimeSelect
                          selected={endDate}
                          onChange={handlePromoEnd}
                          {...register("promo_end")}
                          dateFormat="MM/dd/yyyy"
                        />
                        <div id="promotion_endsHelp" className="form-text">
                          End date of the promotional period
                        </div>
                      </div>
                    </div>
                  </div>

                  <input
                    type="submit"
                    className="btn btn-dark"
                    value="Add Product"
                    disabled={!isEANUnique || !isArticleCodeUnique}
                  />
                </form>
              </div>
              {/* <div className="col-md-4">
                <div className="card my-5 ">
                  <img
                    className="card-img-top"
                    src={productPhoto}
                    alt="Card image cap"
                  />
                  <div className="card-body">
                    <h5 className="card-title">ProductCover Photo</h5>
                  </div>
                  <div className="card-footer">
                    <button className="btn btn-primary">Go somewhere</button>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
      {/* <DevTool control={control} placement="top-left" /> */}
      <Toaster position="bottom-right" />
      {/* Package Info Modal */}
      <PackageModal show={modalVisible} handleClose={closeModal} />{" "}
    </div>
  );
};

export default AddProduct;
